import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

// We created our own Card, this is old ones #JIRA-DS53
export const createMuiCard = () =>
  ({
    MuiCard: {
      styleOverrides: {
        root: {
          //
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: spacing(1),
          '&:last-of-type': {
            paddingBottom: spacing(1),
          },
        },
      },
    },
  }) satisfies ComponentCreation
